import sharingImg from '@/assets/images/share-fill.svg';
import volumeOffImg from '@/assets/images/volumeMute.svg';
import pauseImg from '@/assets/images/pause-fill.svg';
import closeButtonImg from '@/assets/images/closeButton.svg';

const MENU_ICON_SHADOW = 'drop-shadow(0 -1px .75px rgba(0, 0, 0, .38)) drop-shadow(0 0 .75px rgba(0, 0, 0, .42)) drop-shadow(0 1px .5px rgba(0, 0, 0, .18)) drop-shadow(0 2px 3px rgba(0, 0, 0, .2))';
const SAFARI_MENU_ICON_SHADOW = 'drop-shadow(0 0 1px rgb(0 0 0 / 0.60)) drop-shadow(1px 0 0 rgb(0 0 0 / 0.26)) drop-shadow(-1px 0 0 rgb(0 0 0 / 0.26)) drop-shadow(0 1px 0 rgb(0 0 0 / 0.22)) drop-shadow(0 -1px 0 rgb(0 0 0 / 0.22)) drop-shadow(0 2px 4px rgb(0 0 0 / 0.20))';

const isSafari = () => {
  const userAgent = window.navigator.userAgent;
  return /Safari/.test(userAgent) && !/(Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android)/.test(userAgent);
};

const applyMenuIconShadow = (icon) => {
  // Safariでfilterの上側が切れないよう透明余白を確保し、影は各アイコンへ付与する
  const shadow = isSafari() ? SAFARI_MENU_ICON_SHADOW : MENU_ICON_SHADOW;
  icon.style.boxSizing = 'content-box';
  icon.style.padding = '2px';
  icon.style.margin = '-2px';
  icon.style.filter = shadow;
  icon.style.webkitFilter = shadow;
};

export const desktopMenuArea = () => {
  const iconsDiv = document.createElement('div');
  iconsDiv.className = 'storeeel-menu-area-icons';
  iconsDiv.style.display = 'flex';
  iconsDiv.style.alignItems = 'center';
  iconsDiv.style.justifyContent = 'flex-end'; // 右寄せにする
  iconsDiv.style.padding = '11px';
  iconsDiv.style.gap = '15px'; // 要素間の間隔
  iconsDiv.style.marginTop = '10px';
  iconsDiv.style.position = 'fixed';
  iconsDiv.style.top = '0';
  iconsDiv.style.right = '0';
  iconsDiv.style.width = 'fit-content';
  iconsDiv.style.zIndex = '100';

  // 共有アイコンの作成
  const sharingIcon = document.createElement('img');
  sharingIcon.src = sharingImg;
  sharingIcon.alt = 'sharing';
  sharingIcon.style.width = '26px';
  sharingIcon.style.height = '26px';
  sharingIcon.style.aspectRatio = '1 / 1';
  sharingIcon.style.cursor = 'pointer';
  sharingIcon.id = 'sharing-desktop';
  applyMenuIconShadow(sharingIcon);

  // 音量オフアイコンの作成
  const volumeIcon = document.createElement('img');
  volumeIcon.src = volumeOffImg;
  volumeIcon.alt = 'volume';
  volumeIcon.style.width = '38px';
  volumeIcon.style.height = '38px';
  volumeIcon.style.aspectRatio = '1 / 1';
  volumeIcon.style.cursor = 'pointer';
  volumeIcon.className = 'storeeel-volume';
  volumeIcon.id = 'volume-desktop';
  volumeIcon.setAttribute('data-muted', 'true');
  applyMenuIconShadow(volumeIcon);

  // 閉じるボタンの作成
  const closeButton = document.createElement('img');
  closeButton.src = closeButtonImg;
  closeButton.className = 'cross-close-button-parent';
  closeButton.style.display = 'inline-block';
  closeButton.style.verticalAlign = 'middle';
  closeButton.style.position = 'relative'; // position: relativeに変更
  closeButton.style.cursor = 'pointer';
  closeButton.style.width = '33px';
  closeButton.style.height = '33px';
  closeButton.style.aspectRatio = '1 / 1';
  applyMenuIconShadow(closeButton);

  // PCでは閉じるボタンの左隣から再生を止められるようにする
  const pauseButton = document.createElement('img');
  pauseButton.src = pauseImg;
  pauseButton.alt = 'pause';
  pauseButton.style.width = '38px';
  pauseButton.style.height = '38px';
  pauseButton.style.aspectRatio = '1 / 1';
  pauseButton.className = 'storeeel-video-control';
  pauseButton.id = 'pause-desktop';
  pauseButton.style.cursor = 'pointer';
  applyMenuIconShadow(pauseButton);

  // アイコンをアイコンコンテナに追加
  iconsDiv.appendChild(volumeIcon);
  iconsDiv.appendChild(sharingIcon);
  iconsDiv.appendChild(pauseButton);
  iconsDiv.appendChild(closeButton);

  const htmlString = `
    ${iconsDiv.outerHTML}
  `;

  return htmlString;
}
